import type { RefObject } from 'react';
import { createContext } from 'react';

export interface ScrollCollapse {
  scrollProgress: number;
  getInterpolatedValue: (max: number, min: number) => number;
  headerRef?: RefObject<HTMLDivElement>;
}

export const ScrollCollapseContext = createContext<ScrollCollapse | undefined>(
  undefined,
);

ScrollCollapseContext.displayName = 'ScrollCollapseContext';
